import { render } from "./Sidebar.vue?vue&type=template&id=1d4234b8"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=1d4234b8&lang=css"
script.render = render

export default script